import React from 'react';
import { Link } from 'react-router-dom';
import { FiTarget, FiTrendingUp, FiUsers, FiZap } from 'react-icons/fi';
import './CoachifyPages.css';
import CoachifyLogo from '../../assets/logos/CoachifyHoriLogo.png';

const About = () => {
  return (
    <div className="coachify-page">
      {/* Header Navigation */}
      <header className="coachify-header">
        <div className="header-logo">
          <Link to="/" className="logo-link">
            <img src={CoachifyLogo} alt="Coachify" className="header-logo-img" />
          </Link>
        </div>
        <nav className="coachify-nav">
          <Link to="/about" className="nav-link active">About</Link>
          <Link to="/features" className="nav-link">Features</Link>
          <Link to="/pricing" className="nav-link">Pricing</Link>
          <Link to="/contact" className="nav-link">Contact</Link>
        </nav>
      </header>

      {/* Hero Section */}
      <section className="page-hero">
        <div className="page-container">
          <h1 className="page-title">Empowering Gyms to Transform Lives</h1>
          <p className="page-subtitle">
            The all-in-one white-label platform that helps gyms deliver world-class
            nutrition coaching and fitness programming to their members.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="page-content">
        <div className="page-container">
          {/* Our Story */}
          <div className="content-section">
            <h2 className="section-title">Our Story</h2>
            <p className="section-text">
              Coachify was born from a simple observation: gyms have incredible expertise in
              fitness and nutrition, but managing client programs, tracking progress, and
              delivering personalized coaching at scale is a monumental challenge. Traditional
              gym management software focuses on memberships and scheduling, leaving the actual
              coaching experience fragmented across spreadsheets, apps, and manual processes.
            </p>
            <p className="section-text">
              We built Coachify to bridge that gap. Our platform combines science-based nutrition
              planning with sophisticated workout programming, wrapped in a white-label solution
              that becomes your gym's branded coaching platform. No more juggling multiple tools.
              No more manual tracking. Just pure, data-driven coaching that scales with your business.
            </p>
          </div>

          {/* What Makes Us Different */}
          <div className="content-section">
            <h2 className="section-title">What Makes Us Different</h2>
            <div className="features-grid">
              <div className="feature-box">
                <div className="feature-icon">
                  <FiZap />
                </div>
                <h3 className="feature-title">Integrated Platform</h3>
                <p className="feature-text">
                  Unlike other gym software that focuses solely on memberships or workouts,
                  Coachify integrates nutrition science and fitness programming into one
                  seamless experience.
                </p>
              </div>

              <div className="feature-box">
                <div className="feature-icon">
                  <FiTarget />
                </div>
                <h3 className="feature-title">Science-Based Approach</h3>
                <p className="feature-text">
                  Our macro calculations use evidence-based formulas (Mifflin-St Jeor equation)
                  with customizable goals, activity multipliers, and body composition tracking.
                </p>
              </div>

              <div className="feature-box">
                <div className="feature-icon">
                  <FiUsers />
                </div>
                <h3 className="feature-title">White-Label Solution</h3>
                <p className="feature-text">
                  Your brand, your platform. Coachify becomes your gym's proprietary coaching
                  system, strengthening member loyalty and differentiation in your market.
                </p>
              </div>

              <div className="feature-box">
                <div className="feature-icon">
                  <FiTrendingUp />
                </div>
                <h3 className="feature-title">Scalable Efficiency</h3>
                <p className="feature-text">
                  Template systems, bulk client assignments, and automated progress tracking
                  mean your coaches can manage more clients without sacrificing quality.
                </p>
              </div>
            </div>
          </div>

          {/* Our Mission */}
          <div className="content-section mission-section">
            <h2 className="section-title">Our Mission</h2>
            <p className="mission-text">
              To empower gyms worldwide with technology that amplifies their coaching impact,
              deepens client relationships, and builds sustainable, scalable businesses.
            </p>
          </div>

          {/* CTA */}
          <div className="content-section cta-section">
            <h2 className="section-title">Ready to Transform Your Gym?</h2>
            <p className="section-text">
              Join leading gyms who have modernized their coaching delivery with Coachify.
            </p>
            <Link to="/contact" className="cta-button">Get Started Today</Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="coachify-footer">
        <p>&copy; 2025 Coachify. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default About;
